import { Button, DialogContent, Dialog, DialogTitle, FormControl, MenuItem, Select, type SelectChangeEvent } from "@mui/material";
import { ThemeProvider } from "@mui/system";
import { Component } from "react";
import PopinaRestaurant from "../../controller/model/popina/PopinaRestaurant";
import { PopinaPaymentMethodsInterface } from "../../controller/model/popina/interface";
import { EstablishmentPaymentDialogState } from "../Obypay/_interfaces/obypay";
import { Close } from "@mui/icons-material";
import { popinaTheme } from "../../utils/theme";

interface EstablishmentPaymentDialogProps {
    isOpen: boolean
    restaurant: PopinaRestaurant
    _handleSelectValueChange: (selected: SelectChangeEvent<string>, obyPayPaymentMethod: string) => void
    paymentMapping: EstablishmentPaymentDialogState["paymentMapping"]
    _onClickValidate: () => void
    _onCloseDialog: () => void
}

class EstablishmentPaymentDialog extends Component<EstablishmentPaymentDialogProps> {
    obyPayPaymentMethods = [
        {
            name: 'POS card',
            value: 'pos_card'
        },
        {
            name: 'POS lunchvoucher',
            value: 'pos_lunchvoucher'
        },
        {
            name: 'ONLINE card',
            value: 'online_card'
        },
        {
            name: 'ONLINE wallet',
            value: 'online_wallet'
        },
        {
            name: 'ONLINE bancontact',
            value: 'online_bancontact'
        },
        {
            name: 'ONLINE lunchvoucher',
            value: 'online_lunchvoucher'
        },
        {
            name: 'ONLINE intercard',
            value: 'online_intercard'
        },
        {
            name: 'ONLINE bankroll',
            value: 'online_bankroll'
        },
        {
            name: 'ONLINE epro',
            value: 'online_epro'
        }
    ]

    render() {
        const { isOpen, restaurant, _handleSelectValueChange, paymentMapping, _onClickValidate, _onCloseDialog } = this.props;
        return (
            <Dialog open={isOpen} onClose={_onCloseDialog} fullWidth>
                <Close style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }} onClick={_onCloseDialog} />
                <DialogTitle style={{ color: "#474F5E" }}>
                    Liaison des payments
                    <hr style={{ border: "2px solid #474F5E" }} />
                </DialogTitle>
                <DialogContent
                    style={{
                        backgroundColor: "#F1F1F5",
                        borderBottom: "1px solid #7ABF92",
                    }}
                >
                    <ThemeProvider theme={popinaTheme}>
                        <div>
                        {
                            this.obyPayPaymentMethods.map((paymentMethod, index) => {
                                return (
                                    <FormControl fullWidth={true} key={index}>
                                    <div style={{ display:'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', marginBottom: '20px' }}>
                                        <div style={{ width: "150px" }}>{paymentMethod.name} :</div>
                                        <Select
                                          id="paymentMethod"
                                          fullWidth={true}
                                          variant="outlined"
                                          value={paymentMapping[paymentMethod.value as keyof EstablishmentPaymentDialogState["paymentMapping"]]}
                                          onChange={(selected) => {
                                            _handleSelectValueChange(selected, paymentMethod.value)
                                          }}  
                                        >
                                            {
                                                restaurant?.paymentMethods.map((paymentMethod: PopinaPaymentMethodsInterface, index: number) => (
                                                    <MenuItem key={index} value={paymentMethod.client_id}>{paymentMethod.name}</MenuItem>
                                                ))
                                                
                                            }
                                        </Select>
                                    </div>
                                </FormControl>
                                )
                            })
                        }
                        </div>
                    </ThemeProvider>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button onClick={_onClickValidate} color="secondary" variant="contained" style={{ color: "white" }}>Valider</Button>
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

export default EstablishmentPaymentDialog;